document.addEventListener('DOMContentLoaded', ()=>{
  const faq_boxes = document.querySelectorAll('.faq-box');
  faq_boxes.forEach((elm)=>{
    elm.setAttribute('tabindex', 0);
    elm.addEventListener('keydown', (e)=>{
      if(e.code == 'Enter') {
        elm.click(); 
      }
    });
  });
});

jQuery('.faq-box').on('click', function() {
  jQuery(this).next().slideToggle();
  // alert('click');
  jQuery(this).children('.faq-box-icon').toggleClass('is-open');
});

jQuery('.icon--dot').on('click', function() {
  jQuery(this).next().slideToggle();
  // alert('click');
  jQuery(this).children('.icon--dot').toggleClass('is-open');
});

jQuery('a[href^="#"]').on('click', function() {
  var header = document.querySelector('.header__row').clientHeight;
  console.log(header);
  var id = jQuery(this).attr('href');
  var position = jQuery(id).offset().top - header;
  //console.log(id);
  jQuery('html,body').animate({
    scrollTop: position
  },
  300);
});